const constants = {
	BaseUrl: process.env.REACT_APP_URLS_FOR_BASE,
	EnviromentName: process.env.REACT_APP_ENV,
	ApiUrl: process.env.REACT_APP_API_URL,
	AdminApiUrl: process.env.REACT_APP_API_ADMIN_URL,
	UserApiURL: process.env.REACT_APP_API_USER_URL,
	HrefURL: process.env.REACT_APP_URLS_FOR_HREF,
	AppURL:process.env.REACT_APP_URL,
	SECRET_KEY : "ImageBank@2025",
	DateFormat: "MMM DD, YYYY",
	DateFormatPayload:"YYYY-MM-DD",
	ErrorMessage: "Something Went Wrong",
	Home: "Home",
	Back: "Back",
	SiteTitle: "Plural's Image Bank",
	//ADD AND EDIT IMAGE
	WatermarkInfo:"A watermark will be automatically added during upload. If the watermark size is incorrect, kindly change the settings below & re-upload the image.",
	Upload: "Upload",
	AddImage: "Add Image",
	EditImage: "Edit Image",
	Legend: "Legend",
	EnterFigure: "Enter Figure No(s).",
	FigureValidation: "Only numbers (0-9), and dashes (-) are allowed.",
	FigureValidateMessage:"Invalid Figure No(s).",
	EnterLegend: "Enter Legend",
	DetailLegend: "Enter the legend of the image.",
	Book: "Book Title",
	Images:"Images",
	BookText:"Book",
	EnterBook: "Select Book Title",
	NoImagesFound: "No image(s) found.",
	LoadingBook: "Loading Book...",
	DownloadHTMLBook: "Download Book (.html)",
	EnterBookTitle: "Enter book title",
	Image: "Image",
	NoOfImages:"No. of images added",
	ImageHeader: "Image Details",
	CaptionHeader: "Caption Details",
	BookHeader: "Book Details",
	UploadImage: "Upload Image",
	ImageInstruction: "Image with the watermark must be added.",
	Description: "Description",
	EnterDescription: "Enter Description",
	DetailDescription: "Enter the description of the image",
	Submit: "Submit",
	Save: "Save",
	InvalidFileFormat: "Invalid file format",
	Category: "Category",
	Subject: "Subject",
	CategoryCode: "Code",
	DetailCategory: "Select Category(s)",
	Author: "Author(s)",
	DetailAuthor: "Select the Author(s)",
	ISBN: "ISBN-13",
	Cancel: "Cancel",
	ImageAddedSuccess: "Image added successfully",
	ImageAddedError: "Failed to add image",
	ImageEditSuccess: "Image updated successfully",
	ImageEditError: "Failed to update image",
	Published: "Published",
	NotPublished: "Not Published",
	UnPublish:"Unpublish",
	Figure:"Figure",
	Status:"Status",
	ListImageFilters: [
		{
			text: 'Published',
			value: '1',
		},
		{
			text: 'Not Published',
			value: '0',
		},
	],
	NoData: "No image(s) found",
	NoDataFound: "No Data Found",
	Subjects:"Subjects",
	//LIST IMAGES
	ListImage: "Images",
	FigureNo: "Figure No(s).",
	Edit: "Edit",
	Publish: "Publish",
	NoImages: "Failed to list Images",
	Ok:"Ok",
	Reset:"Reset",
	NewImage: "New Image",
	Delete:"Delete",
	SelectAdminUser:"Select Admin User",
	//LIST REQUESTED IMAGES
	PendingRequests: "Pending Requests",
	ListRequests: "Requested List",
	ViewRequests: "View Request(s)",
	Approve: "Approve",
	ApproveAll: "Approve all",
	DeclineAll:"Decline all",
	CancelAll:"Cancel all",
	//VIEW CART
	ViewCart: "Cart",
	ViewCollections: "Collections",
	AddToCart: "Add to Cart",
	Remove: "Remove",
	RequestPermission: "Request Permission",
	Add: "Add",
	//HOME PAGE
	LastUploads: "Your Last Uploads",
	LatestRegister: "Latest Registrations",
	//REGISTER
	Register: "Create account",
	Username: "Username",
	Password: "Password",
	ConfirmPassword: "Confirm Password",
	FirstName: "First Name",
	LastName: "Last Name",
	Email: "Email",
	ContactNumber: "Contact Number",
	Title: "Title",
	Institution: "Institution",
	Address: "Address",
	Country: "Country",
	State: "State",
	City: "City",
	FaxNumber: "Fax Number",
	ZipCode: "Zip Code",
	EnterUsername: "Enter username",
	EnterFirstName: "Enter first name",
	EnterLastName: "Enter last name",
	EnterPassword: "Enter password",
	EnterConfirmPassword: "Enter confirm password",
	EnterEmail: "Enter email",
	EnterContactNumber: "Enter contact number",
	EnterTitle: "Enter title",
	EnterInstitution:"Enter institution",
	SelectCountry: "Select a country",
	SelectState: "Select a state",
	SomethingWentWrong: "Something went wrong. Please try again.",
	UsernameLengthValidation: "Username must be between 5 to 12 characters.",
	UsernameValidation: "Only letters (a-z), numbers (0-9), underscore (_) and dot (.) are allowed.",
	FirstNameInvalid: "Invalid First Name",
	LastNameInvalid: "Invalid Last Name",
	UsernameTooltip: "Username must be unique, a single word, having between 5 to 12 characters. It can contain only letters (a-z, A-Z), numbers (0-9),  underscore (_) and dot (.).",
	PasswordTooltip: "Password length should be minimum 8 characters. It must contain at least 1 uppercase letter, 1 lowercase letter, a number, any special character and no spaces.",
	EmailTooltip: "All communication from this website will be sent to this email address.",
	AccountAlready: "Already have an account?",
	//LOGIN
	UsernameEmail: "Username or Email",
	EnterUserNameOrEmail: "Enter Username or Email",
	Login: "Login",
	WelcomeBack: "Welcome back!",
	Admin: "Admin",
	LogOut: "Logout",
	ForgotPassword: "Forgot Password?",
	NoAccount: "Don't have an account?",
	CreateAccount: "Create account",
	AdminLogin: "Admin Login",
	LoginOrSignUp: "Login/Sign Up",
	//USER LIST
	Action: "Action",
	AdminUsers: "Admin Users",
	SearchUser: "Search by user",
	//FORGOT PASSWORD
	ForgotYourPassword: "Forgot Your Password?",
	InstructionsForgotPassword: "Enter your Username/Email below. We will send you instructions to reset your password.",
	//RESET PASSWORD
	ResetPassword: "Reset Password",
	NewPassword: "New Password",
	EnterNewPassword: "Enter New Password",
	ConfirmNewPassword: "Confirm New Password",
	RetypeNewPassword: "Re-type New Password",
	ChangePassword: "Change Password",
	BackToLogin: "Back to Login",
	PasswordsDoNotMatch: "The two passwords that you entered do not match!",
	//MY PROFILE
	MyProfile: "My Profile",
	//USER DASHBOARD
	LatestUploads: "Latest Uploads",
	TopRequestedImages:"Top Requested Images",
	SeeMore: "See more",
	AddedToCollection: "Added to Collection",
	AddToCollection: "Add to Collection",
	Close: "Close",
	Preview: "Preview",
	SignUp: "Sign Up",
	BrowseAndSelect: "Browse and select from a wide array of content.",
	AnatomicalIllustrations: "Anatomical illustrations, diagnostic charts, therapeutic visuals, and more.",
	SubHeader: (
		<p>
			This searchable database contains images (illustrations, photos, graphs,
			etc.) copyrighted by Plural Publishing, Inc. <br />
			Upon approval, you may use images from this collection. Once approved, the image files will be sent to you.
		</p>
	),
	Header: (
		<h2 className="text-2xl font-light sm:text-4xl">
			Welcome to <b>Plural's Image Bank</b>
		</h2>
	),
	BrowseBySubject: "Browse by Subject",
	Categories: "Categories",
	//HEADER
	ImageBank: "Image Bank",
	TotalEntries: "Total Entries",
	UserBased: "User-Based",
	ImageBased:"Image-Based",
	WebsiteUsers: "Website Users",
	Website: "Website",
	// ADMIN DASHBOARD
	Dashboard: "Dashboard",
	SearchText:"Search by keyword, author, book title, or ISBN-13",
	SearchBookText:"Search by book title, author, subject, or ISBN-13",
	SearchTextCollection:"Search by keyword",
	SearchBy:"Search by keyword, or book title",
	//VIEW COLLECTION
	MyCollections:"My Collection",
	MoveToCollection:"Move to collection",
	//REQUEST PERMISSION
	BookJournalTitle:"Book/Journal title",
	ChapterTitle:"Chapter/Article title",
	AuthorEditor:"Author(s)/Editor(s)",
	MaterialsUsed:"How will this material be used?",
	DescribeIntendedUse:"Describe Intended Use of Plural Content.",
	IntendedUse:"Intended Use of Plural Content.",
	Details:"Details on intended use",
	Publisher:"Publisher",
	PublicationDate:"Publication date",
	PublicationYear: "Publication year",
	EstimatedPrintRun:"Estimated print run",
	CopyrightYear:"Copyright year",
	ProductCode:"Product code",
	Edition:"Edition",
	EnterAuthors:"Enter Author(s)",
	EnterPublicationDate:"Enter Publication Date",
	EnterCopyrightYear:"Enter Copyright Year",
	SelectCategory: "Select a Category",
	EnterCategory: "Enter Category",
	EnterSubject: "Enter Subject",
	EnterCategoryCode: "Enter Category Code",
	SelectSubject:"Select a Subject",
	EnterProductCode:"Enter Product Code",
	EnterISBN:"Enter ISBN-13 number",
	ImageAddedToCollection:"Added to Collection",
	ImageRemovedFromCollection:"Removed from Collection",
	ImageAddedToWishlist:"Added to Wishlist",
	ImageRemovedFromWishlist:"Removed from Wishlist",
	UsedForTypes : [
		{ key: 0, value: "In a book" },
		{ key: 1, value: "In a journal" },
		{ key: 2, value: "In a coursepack" },
		{ key: 3, value: "In a conference/seminar" },
		{ key: 4, value: "On a website" },
		{ key: 5, value: "In a thesis/dissertation" },
	],
	RequestPermissionSuccess:"Request sent",
	RequestPermissionFailed:"Failed to request permission",
	UsedFor:"Used For",
	Date:"Date",
	// ADMIN LISTING
	SearchAdmin: "Search by admin user",
	EditAdminDetails: "Edit Details",
	AddAdminDetails: "Add Details",
	AddAdmin: "New Admin",
	Name:"Name",
	DateCreated: "Date Created",
	DeleteAdminUserConfirm:"Are you sure you want to delete the admin user?",
	//PENDING LIST
	UserList:"User list",
	RequestList:"Request list",
	OtherPendingRequests:"All Pending Requests",
	PendingRequestDetails:"Pending Request Details",
	ListPreviousRequests:"List Previous Requests",
	RequestedDate:"Requested Date: ",
	RequestedFor: "Requested For: ",
	UserWiseRequestList:"Request List User",
	PreviousRequestList:"Previous Requests",
	AllUserRequestList: "All Requests",
	RequestDetails:"Request Details",
	MyRequests:"My Requests",
	UserRequests:"User Requests",
	ConfirmAll:"all Images",
	ConfirmPending:"Pending Images",
	RequestId:"Request ID: ",
	UpdatedBy:"Updated by",
	//WISHLIST
	MyWishlist:"My Wishlist",
	Wishlist:"Wishlist",
	AddToWishlist:"Add to Wishlist",
	NotAuthorizedText:"Sorry, you are not authorized to access this page.",
	PageNotFoundText:"Sorry, the page you visited does not exist.",
	Accept:"Accept",
	Decline:"Decline",
	ApprovedRequest:"Approved Request",
	DeclinedRequest:"Declined Request",
	CancelledRequest:"Canceled Request",
	Pending:"Pending",
	Approved:"Approved",
	Declined:"Declined",
	Canceled:"Canceled",
	Completed: "Completed",
	Checked:"Checked",
	ResetFilters:"Reset Filters",
	ShowFigNo:"Show Figure No.",
	StatusType:{
		"0":"Pending",
		"1":"Approve",
		"2":"Decline",
		"3":"Cancel"
	},
	StatusTypePastTense:{
		"0":"Pending",
		"1":"Approved",
		"2":"Declined",
		"3":"Canceled"
	},
	// FOOTER
	PrivacyPolicy: "Privacy Policy",
	AboutPlural: (
		<p className="text-base">
			Plural Publishing produces leading academic, scientific and clinical publications in the fields of speech-language pathology, audiology, special education, singing and otolaryngology.
		</p>
	),
	ContactPhrase: "Should you have a question or problem, please contact our Permissions Department.",
	UsefulLinks: "Useful links",
	Contact: "Contact",
	ContactDays: "Monday–Friday",
	ContactTimings: "8 a.m.–5 p.m. (PST)",
	ContactEmail: (<a
		href="mailto:permission@pluralpublishing.com"
		aria-label="Contact Email"
		className="hover:text-white hover:underline text-base active:text-secondary active:underline"
	>
		permission@pluralpublishing.com
	</a>),
	PluralPublishingSiteLink: (
		<a href="https://www.pluralpublishing.com" target="_blank" rel="noopener noreferrer" className="active:text-secondary active:underline hover:text-white hover:underline text-base">pluralpublishing.com</a>
	),
	VisitSite: "Visit our website",
	// PRIVACY POLICY
	PrivacyContent: (
		<>
			<p>This web site is owned and operated by Plural Publishing, Inc., with headquarters at 5521 Ruffin Road, San Diego, CA, USA, and its affiliates ("Plural Publishing", "we", "our", or "us"). This privacy policy ("Privacy Policy") explains to our customers and visitors ("you", "your") how we collect, use and disclose personal information that we obtain through this web site.</p>
			<p><strong>General information:</strong>&nbsp;Plural Publishing, Inc. is committed to responsible internet citizenship and the privacy of our customers and those visiting our website. Our user information is carefully safeguarded, and is never sold or marketed to third parties.</p>
			<p><strong>Data Collection:</strong>&nbsp;Plural Publishing is dedicated to protecting the privacy of all personal information collected through this website. We may collect personal information during the checkout process used to access certain portions of our website or to use other functions or features, as noted. Plural Publishing may collect and use personally identifiable information including, but not limited to, the following: name, address, phone number, fax number, email address, employer, title, course information, credit card information, and IP address. Any demographic information we request is generally used in aggregate form for various analyses conducted by Plural Publishing regarding our website and related materials. Plural Publishing also collects general use information that does not specifically identify you.</p>
			<p><strong>Use of Information Collected on Plural Publishing's Site:</strong>&nbsp;We use personal information to provide the highest quality of service to our customers, prospects, and general visitors to this website. This may include using and reporting of de-identified, anonymous, aggregated data. In addition to the specific purposes for which we collect certain data, as described further in this Privacy Policy, Plural Publishing may collect personal information in connection with any online employment applications, or so that we can contact you, provide materials to you upon your request, keep you posted on new Plural Publishing products and services, track your orders, register you, send relevant messages via e-mail or postal mail, or for any other purpose identified when personal information is collected. The Plural Publishing website provides a way to indicate that you do not wish to receive these messages in which case we will remove your information from the appropriate list.</p>
			<p><strong>Shopping cart/Review Copy Cart:</strong>&nbsp;Both our online Shopping Cart and our Exam Copy Cart use your email address to track your order. This allows us to automatically send you a receipt and a shipping confirmation electronically, and to contact you in case of a problem or a need for more information to process your order. We reserve the right to send you periodic communications for marketing and promotional purposes. When you order from us, we may ask you at the end of your order if you would like to receive email (see below), but you will not be signed up automatically. You will need to manually click the indicated link, choose one or more product categories, and then submit a form to get signed up for email updates.</p>
			<p><strong>Email:</strong>&nbsp;Our email messages are based on an opt-in system, and are not considered unsolicited commercial email (SPAM). If you received such a message from us, someone using that address signed up to receive our messages. If you are the owner of this account and did not sign up, you may remove your email address by clicking the unsubscribe link at the bottom of the email. This will permanently remove your address from Plural Publishing email distribution list unless you choose to join again later.</p>
			<p><strong>Information Sharing:</strong>&nbsp;Plural Publishing will not sell, rent, trade or lease your personal information to others unless we have requested to do so and have received your permission, provided, however, that you authorize Plural Publishing to disclose your personal information to others under the following circumstances: We may, and you authorize Plural Publishing to, transfer your personal information to any Plural Publishing affiliate (or business partner or agent acting on our behalf) worldwide for purposes described herein. Such Plural Publishing affiliates, business partners, and agents will be under the same obligations as is Plural Publishing under this Privacy Policy. We may be required to transfer your personal information by law or under a court order or in connection with an organizational change, such as a merger or acquisition by another company or the sale of Plural Publishing’s assets. If Plural Publishing, in its sole discretion, determines that that a transfer is necessary to protect the rights, property, or safety of Plural Publishing or its personnel, or this site or its users, then we may also share your personal information. Any personal information and student and faculty data collected or used in connection with Plural Publishing Product Use, may be shared with third parties as described in each applicable Plural Publishing product and related Plural Publishing terms of use, with necessary consents as may be required and also described therein.</p>
			<p><strong>Data Protection:</strong>&nbsp;Plural Publishing is committed to ensuring the security of your information. We use industry-standard processes designed to protect sensitive data, however, because of the nature of internet, we cannot guarantee the security of the information you transmit, so you should take precautions to protect your personal information when you are on the internet, such as changing passwords often, using a combination of letters and numbers when creating passwords, and using a secure browser.</p>
			<p><strong>Consent:</strong>&nbsp;By use of the Plural Publishing website, and entry of any personal information into this site or in any Plural Publishing program accessed through our website, you are consenting to the collection, use, and transfer of your personal information as outlined in this Privacy Policy. If you are located outside the United States, your use and entry of personal information into this site constitutes your consent to the transfer of your personal information into the United States. Although we do not normally collect any sensitive personal information (such as ethnicity or race, religious beliefs or medical conditions), your entry of any such sensitive information on this web site is your express consent to the collection, use and transfer of such information.</p>
			<p><strong>Cookies and other Tracking Devices:</strong>&nbsp;Plural Publishing may use cookies, IP addresses, and other passive tracking devices to collect aggregate statistics about our website. We use this information to monitor the performance of this site so we can improve its use and add features and programs to make it more effective. Plural Publishing may also disclose this aggregate information to third parties. You may choose to set your browser settings to disable cookies, however, please note that if you do so, you may not be able to complete certain activities or access certain information on our web site.</p>
			<p><strong>Surveys and Drawings:</strong>&nbsp;From time-to-time, Plural Publishing may request information from users via surveys or drawing entries. Participation in these surveys or drawings is completely voluntary, so you can decide whether you want to provide the information. Information requested may include contact information (such as name and address), and demographic information (such as postal code, age range). If you give Plural Publishing information in connection with an Plural Publishing drawing, survey, or similar promotion, you agree that we can use that information to manage those activities. Contact information will be used to notify the winners and award prizes, if applicable.</p>
			<p><strong>Revisions to this Privacy Policy:</strong>&nbsp;Plural Publishing reserves the right to revise this Privacy Policy at any time, without notice, so please review this Privacy Policy frequently. Each version of this Privacy Policy will have a date, as noted below.</p>
			<p><strong>Feedback:</strong>&nbsp;If you have any questions or comments about Plural Publishing's Privacy Policy, please contact us by email at <a href="mailto:information@pluralpublishing.com" className="text-secondary hover:underline">information@pluralpublishing.com</a></p>
			<p>To request the deletion of your personal data under GDPR's Right to Be Forgotten, please email us at  permission@pluralpublishing.com with the subject 'Forget Me Request,' and we will process your request within 30 days.</p>
			<p><em>Plural Publishing Privacy Policy (Rev July2013)</em></p>
		</>
	),
	// FAQs
	FAQs: "FAQs",
	FAQData: [
		{
			subheader: 'About the Image Bank',
			questions: [
				{ question: "What is Plural's Image Bank?", answer: "The Image Bank is a searchable database containing images (illustrations, photos, graphs, etc.) that are copyrighted by Plural Publishing. It is a secure, cloud-based site where users can browse and request permission to reuse Plural's images. The images are watermarked by Plural Publishing. Once a request is approved, a Plural team member will send you the digital files without a watermark." },
				{ question: 'Who can use the Image Bank?', answer: (<p>The image bank is located at <a href={process.env.REACT_APP_URL} target="_blank" rel="noopener noreferrer" className="text-secondary hover:underline">imagebank.pluralpublishing.com</a> and you can access it from any internet-connected device, including a mobile phone, tablet, or desktop computer.</p>) },
				{ question: 'How do I access the Image Bank?', answer: 'The Image Bank is currently available to Plural Publishing authors, editors, and contributors. Browsing does not require an account; however, an account is required to select images and request permission for reuse.' },
				{ question: 'How are the images organized?', answer: 'Each image is tagged with metadata, including subject category, book title, author, description/legend, and ISBN13 to allow for easy search and filtering.' },
				{ question: 'Can I request multiple images at once?', answer: 'Yes. You can add multiple images to your request and submit them in a single batch.' },
			],
		},
		{
			subheader: 'Copyright and Permissions',
			questions: [
				{ question: 'Will there be a permission fee to reuse the images I select in the book I am publishing with Plural?', answer: 'No.  Authors may reuse (upon approval) Plural copyrighted images in their book to be published by Plural at no cost.' },
				{ question: 'Will there be a permission fee to use the images I select in a book or journal that is published by another publisher?', answer: 'Yes, a fee will be charged to reuse Plural copyrighted images in any publication produced by another publisher. Unless you were the creator of the image for a Plural book. See #3 below.' },
				{ question: 'Will there be a permission fee to use the images from my Plural book in another work to be released by another publisher?', answer: 'No. Authors may reuse their own Plural copyrighted images (upon approval) in a non-Plural work without a permission fee.' },
				{ question: 'Can I alter the images for use in my publication?', answer: "No. The images may not be altered, adapted, or modified in any way without Plural's permission." },
				{
					question: 'How should I credit the borrowed images in my publication?', answer: (
						<p>
							The following credit line acknowledging Plural's copyright <b>must</b> appear with any borrowed image:<br />
							From <em>[Plural Book Title]</em> by [Author(s)]. Copyright © [Year] Plural Publishing, Inc. Used with permission. All rights reserved.
						</p>
					)
				},
			],
		},
		{
			subheader: 'Image Upload & Metadata',
			questions: [
				{ question: 'Can I upload images to the Image Bank?', answer: 'No. Only Plural staff can add images to the Image Bank.' },
				{ question: 'Can I edit metadata or tags for an image in the Image Bank?', answer: 'No, only Plural Publishing staff can update metadata to ensure accuracy and consistency. We would be grateful for any feedback you might have, so if you find an error or feel information is missing, please contact your Plural editor.' },
			],
		},
		{
			subheader: 'Security & Access',
			questions: [
				{ question: 'Do I need an account to request permission to reuse Plural images?', answer: 'Yes, you must register in order to request images and check the status of your requests.' },
				{ question: 'Can multiple users from the same organization share an account?', answer: 'No. Each user must have an individual account for security reasons. However, institutional licensing options are available upon request.' },
			],
		},
	],
	SearchFAQ: "Search by questions or answers",
	//BOOKS
	AddNewBook:"New Book",
	AddCategory:"New Category",
	AddSubject:"New Subject",
	Books:"Books",
	Search: "Search",
	DeleteBooksConfirm:"Are you sure you want to delete the book?",
	ISBNErrorMssg: "Enter a valid ISBN-13",
	RequestTypeOptions : [
		{
			value: "2",
			label: 'All',
		},
		{
			value: "0",
			label: 'Pending',
		},
		{
			value: "1",
			label: 'Checked',
		},
	],
	Requests:"Requests",
	//FILTER IMAGES
	EditType : [
		{
			label: 'All',
			value: '0',
		},
		{
			label: 'New',
			value: '1',
		},
		{
			label: 'Edit',
			value: '2',
		},
	],
	//TINY MCE TEXT EDITOR
	TextEditorSrcPath:`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`,
	TinyMcePlugins: [],
  TinyMceToolbar: "bold italic underline subscript superscript codeview",
  TinyMceContentStyle: 'body { font-family: Lato, sans-serif; }',
  TinyMcePlaceholder: "Enter text...",
	codeIcon: "</>",
	EditorMode: "Editor mode",
}
export default constants;
